import { App } from '@capacitor/app';
import { WebPlugin } from '@capacitor/core';
// eslint-disable-next-line import/prefer-default-export
export class BiometricAuthBase extends WebPlugin {
    addResumeListener(listener) {
        return App.addListener('appStateChange', ({ isActive }) => {
            if (isActive) {
                this.checkBiometry()
                    .then((info) => {
                    listener(info);
                })
                    .catch(console.error);
            }
        });
    }
}
